/**
 * Behavior for navigational block slice
 */
Drupal.behaviors.rmccNavigationalBLocksSlice = {
  attach(context, settings) {
    once('rmccNavigationalBLocksSLiceBehavior', '.paragraph--type--navigational-blocks-slice', context).forEach((elem) => {

      // Set equal height for blocks
      // Better using imageloaded instead of window load
      $(window).on('load', () => {
        Drupal.rmcc.util.equalheight($('.navigational-blocks > article', $(elem)));
      });

      $(window).on('resize', () => {
        Drupal.rmcc.util.equalheight($('.navigational-blocks > article', $(elem)));
      });
    });
  }
};

